import { useMemo } from 'react'
import { useShowCommercialName } from './use-show-commerial-name'
import { useSingleProductGroup } from './use-single-product-group'

export const useProductName = (product?: { ProductGroups: string[]; CommercialName: string } | null) => {
  const singleProductGroup = useSingleProductGroup(product)
  const showCommercialName = useShowCommercialName(product)
  return useMemo(() => {
    const parts = []
    if (singleProductGroup) {
      parts.push(singleProductGroup)
    }
    // Has commercial name that is not similar to single product group
    if (showCommercialName) {
      parts.push(product?.CommercialName)
    }
    // product has no commercial name and multiple products groups, default to first product group
    if (!parts.length && product?.ProductGroups.length) {
      parts.push(product?.ProductGroups[0])
    }
    return parts.join(', ')
  }, [product, showCommercialName, singleProductGroup])
}
